export default __webpack_public_path__ + "static/media/order-confirmed.80e6bbff.png";